<template>
  <div class="LaptopFilters" @keydown.enter="$emit('fetch')">
    <Btn
      class="xs toggle"
      :class="{ danger: hasAny && !doShowFilters }"
      @click="doShowFilters = !doShowFilters">
      {{ $t('label') }}
      <Icon :name="doShowFilters ? 'up' : 'down'" />
    </Btn>
    <div v-if="doShowFilters" class="filters">
      <Field
        v-for="({ type }, key) in filters"
        :key="key"
        class="filter"
        :label="$t(`filters.${key}`)"
        :type="type"
        :value="values[key]"
        @update:value="values[key] = $event" />
    </div>
  </div>
</template>

<script>
import { always, any, identity, map } from 'rambda'

const splitIlikeWords = (words, key) => words
  .split(' ')
  .map(word => ({
    [key]: { $ilike: `%${word}%` },
  }))

const filters = {
  name: {
    transform: splitIlikeWords,
    type: 'text',
  },
  gpu: {
    transform: splitIlikeWords,
    type: 'text',
  },
  cpu: {
    transform: splitIlikeWords,
    type: 'text',
  },
  memoryAmount: {
    transform: identity,
    type: 'text',
  },
  screen: {
    transform: splitIlikeWords,
    type: 'text',
  },
  imageFileId: {
    transform: always({ imageFileId: { $gte: 1 } }),
    type: 'checkbox',
  },
}

export default {
  props: {
    filtersLaptop: { type: Object, required: true },
  },
  data() {
    return {
      doShowFilters: false,
      filters,
      values: map(always(null), filters),
    }
  },
  computed: {
    hasAny() {
      return any(Boolean, this.values)
    },
  },
  watch: {
    values: {
      deep: true,
      handler(values) {
        const filtersLaptop = {
          $and: Object
            .entries(values)
            .filter(([_, value]) => !!value)
            .flatMap(([key, value]) => {
              const { transform } = filters[key]

              return transform(value, key)
            }),
        }

        this.$emit('update:filtersLaptop', filtersLaptop)
      },
    },
  },
}
</script>

<style lang="scss">
.LaptopFilters {
  background: $white;
  border-bottom: solid 1px $border-color;
  border-top: solid 1px $border-color;
  margin: 0.5rem 0;
  position: sticky;
  top: 0;
  z-index: 1;

  > .toggle {
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
    width: auto;
    z-index: 2;
  }

  > .filters {
    display: flex;

    > .filter {
      margin: 0.5rem;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "label": "Filters",
    "filters": {
      "name": "Name",
      "gpu": "GPU",
      "cpu": "CPU",
      "memoryAmount": "RAM",
      "imageFileId": "With images",
      "screen": "Screen"
    }
  }
}
</i18n>
